import { PaymentProcessorAccountConfigurationBase } from '../payment-processor-account-configuration-base';

export class PSNPaymentProcessorAccountConfiguration extends PaymentProcessorAccountConfigurationBase {
  accountId: string;

  constructor(options?: Partial<PSNPaymentProcessorAccountConfiguration>) {
    super(options);
  }
}
